import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { CanDeactivateFn, Router } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ConfirmationModalService } from '@retail-portal-santander-frontend/remote-shared-ui-confirmation-modal';
import { CanComponentDeactivate } from '../models';

export const formDeactivationGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
): boolean | Observable<boolean> => {
  const router = inject(Router);
  const confirmationModalService = inject(ConfirmationModalService);

  if (router.getCurrentNavigation()?.extras?.state?.['forceRoute']) {
    return true;
  }

  if (component.canDeactivate()) {
    return true;
  }

  return confirmationModalService.open({
    header: 'Unsaved changes',
    message: 'Are you sure you want to leave this page? Your changes will be lost if you leave this page.',
    acceptButton: {
      label: 'Leave page',
    },
    cancelButton: {
      label: 'Cancel',
    },
    status: 'warning',
  });
};
